module.exports = __webpack_public_path__ + "static/mediation_oben_cropped-e487e27b9200846054798e8c665556fb.jpg";